import { useState, useCallback } from 'react';

/**
 * Custom hook for managing modal state
 * @returns {Object} Modal state and functions
 */
const useModalState = () => {
  const [state, setState] = useState({
    visible: false,
    type: null,
    isFolder: false,
    id: null,
    detail: null,
  });

  /**
   * Open modal with specified parameters
   * @param {string} id - ID of the item
   * @param {string} type - Type of modal to open
   * @param {boolean} isFolder - Whether the item is a folder
   * @param {string} detail - Additional details
   */
  const openModal = useCallback((id, type, isFolder = false, detail = null) => {
    setState({
      visible: true,
      type,
      isFolder,
      id,
      detail,
    });
  }, []);

  /**
   * Close modal and reset state
   */
  const closeModal = useCallback(() => {
    setState({
      visible: false,
      type: null,
      isFolder: false,
      id: null,
      detail: null,
    });
  }, []);

  return {
    state,
    openModal,
    closeModal,
  };
};

export default useModalState;
